





















import NewsItem from '@/components/NewsItem'

export default {
    name: 'News'

    props: ['document']

    components:
        NewsItem: NewsItem

    data: ->
        fields: @defaultFields()

    methods:
        defaultFields: ->
            items: []

        setContent: (document) ->
            fields =
                items: document.items
            $.extend @fields, fields

    created: ->
        @setContent @document
}
